import { useMemo, useCallback } from "react";
import { useDropzone, DropzoneRootProps } from "react-dropzone";
import { baseStyle, activeStyle, acceptStyle, rejectStyle } from "./dropzoneStyles";

interface IProps {
    handleSetFile: (file: File) => void;
    msg: string;
    accept?: any;
    essential:string;
    disabled?: boolean;

}

const acceptDefault = {
    "application/zip": [".zip"],
};

export const FileDropzone = ({ handleSetFile, msg, accept, essential, disabled }: IProps) => {
    const onDrop = useCallback(
        (acceptedFiles: File[]) => {
            handleSetFile(acceptedFiles[0]);
        },
        [handleSetFile]
    );

    const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
        accept: accept === undefined ? acceptDefault : accept,
        disabled: disabled,
        onDrop,
    });

    const style: DropzoneRootProps = useMemo(
        () => ({
            ...baseStyle,
            ...(isDragActive ? activeStyle : {}),
            ...(isDragAccept ? acceptStyle : {}),
            ...(isDragReject ? rejectStyle : {}),
        }),
        [isDragActive, isDragReject, isDragAccept]
    );

    return (
        <div id={`fileDropzone-container-a-${essential}`} className="file-dropzone-container">
            <div id={`rootProps-fileDropzone-${essential}`} {...getRootProps({ style })}>
                <input id={`inputProps-fileDropzone-${essential}`} {...getInputProps()} />
                {msg}
            </div>
        </div>
    );
};
